"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var eventBus;
        (function (eventBus) {
            function publish(eventName, payload) {
                PubSub.publish(eventName, payload);
            }
            eventBus.publish = publish;
            function subscribe(eventName, callback) {
                return PubSub.subscribe(eventName, (_, data) => callback(data));
            }
            eventBus.subscribe = subscribe;
            function unsubscribe(token) {
                PubSub.unsubscribe(token);
            }
            eventBus.unsubscribe = unsubscribe;
            function unsubscribeAll(event) {
                if (event)
                    PubSub.unsubscribe(event);
                else
                    PubSub.clearAllSubscriptions();
            }
            eventBus.unsubscribeAll = unsubscribeAll;
            function propertyUpdated(componentId, propName, propValue, oldValue, propPath) {
                PubSub.publish(designerv2.EVENTS.PROPERTY_UPDATED, { componentId, propName, propValue, oldValue, propPath });
            }
            eventBus.propertyUpdated = propertyUpdated;
            function subscribeToPropertyUpdates(callback) {
                return subscribe(designerv2.EVENTS.PROPERTY_UPDATED, callback);
            }
            eventBus.subscribeToPropertyUpdates = subscribeToPropertyUpdates;
        })(eventBus = designerv2.eventBus || (designerv2.eventBus = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
